import { IApplicationState } from "src/~store/models/ApplicationState";
import "./MailingRecipientsContactsWithVariablesList.css";

import { mailingItemInfoSelector } from "src/app/mailing/~store/selector";
import { MailingRecipientsContactsWithVariablesListProps } from "./~types/MailingRecipientsContactsWithVariablesListProps";
import { connect } from "react-redux";
import { Table } from "reactstrap";
import { useTranslation } from 'react-i18next';

type ReduxType = ReturnType<typeof mapStateToProps> & MailingRecipientsContactsWithVariablesListProps;

const MailingRecipientsContactsWithVariablesList =  (props: ReduxType) => {

    const { t } = useTranslation();
    
    //Unescapes quotes for better readability
    const _formatJsonText = (jsonText: string): string => {
        var obj = JSON.parse(jsonText);
        return JSON.stringify(obj, null, 1);
    }

    return (
        <>
            <Table className="chats-list-table card-table">
                <thead>
                    <tr>
                        <th className="contact-external-id-column">{t('contact.externalId')}</th>
                        <th className="contact-temlate-variables-column">{t('mailing.templateVariables')}</th>
                    </tr>
                </thead>
                <tbody>   
                    {
                        props.mailingItemInfo.recipientFilter?.contactsFilters?.map((filter => 
                        {
                            return (
                                <tr key={filter.externalId}>
                                    <td>{filter.externalId}</td>
                                    <td>
                                        <div className="contact-template-variables-cell-content">{_formatJsonText(filter.variablesJson)}</div>
                                    </td>
                                </tr>
                            )
                        }
                        ))
                    }
                </tbody>
            </Table>
        </> 
    );
}

const mapStateToProps = (state: IApplicationState) => {
    return {
        mailingItemInfo: mailingItemInfoSelector(state),
    };
}

const mapDispatchToProps = (dispatch: any): MailingRecipientsContactsWithVariablesListProps => {
    return {
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MailingRecipientsContactsWithVariablesList);